import Vue from 'vue'
import { GetterTree, MutationTree } from "vuex"

import { getResource } from "~/utils/store"
import { RootState } from "~/store/store.types"

import { HotelsState, HotelsResource, Hotel } from "./hotel.types"

export const state = ():HotelsState => ({
  data: {},
  filters: {}
})

export const getters: GetterTree<HotelsState, RootState> = {
  resourceById (state, _, __, rootGetters) {
    return (id: string, included: string | string[] = []) =>
      getResource<HotelsResource>(state, id, rootGetters, included)
  },
}

export const mutations: MutationTree<HotelsState> = {
  SET_HOTEL (state, hotel: Hotel) {
    const { id } = hotel

    Vue.set(state.data, id, hotel)
  }
}
